export interface APIResponse {
    code: number;
    msg: string;
}

export interface State {
    busy: boolean;
    error: string | null;
}

export const initialAPIResponse = {
    code: 0,
    msg: "",
}

export const initialState: State = {
    busy: false,
    error: null,
}